import { LOCAL_STORAGE_KEYS } from 'config/Vars'

import SafeJSON from 'modules/core/lib/SafeJSON'
import SafeLocalStorage from 'modules/core/lib/SafeLocalStorage'
import { buildWebpageUrl } from 'modules/core/lib/buildUrl'

type TokenInfo = {
  token: string | null
  isExpired: boolean
}

export const getVisitorTokenInfo = (): TokenInfo => {
  const MAX_EXPIRATION_TIME = 12
  const tokenInfo = SafeJSON.parse(
    SafeLocalStorage.getItem(LOCAL_STORAGE_KEYS.visitorToken, null),
    null
  )

  if (!tokenInfo) {
    return { token: null, isExpired: true }
  }

  const hourlyDifference = Math.abs(new Date().getTime() - tokenInfo.createdAtTime) / 36e5

  const isExpired = hourlyDifference > MAX_EXPIRATION_TIME

  return { token: tokenInfo.token, isExpired }
}

const setVisitorTokenInfo = (token: string) => {
  SafeLocalStorage.setItem(
    LOCAL_STORAGE_KEYS.visitorToken,
    JSON.stringify({ token, createdAtTime: new Date().getTime() })
  )
}

type ResponseData = {
  success: boolean
  token: string | null
}

export const identify = async (email: string): Promise<string | null> => {
  const { token, success } = await fetch(buildWebpageUrl('/api/hubspot/identify'), {
    method: 'POST',
    body: JSON.stringify({ email }),
  }).then((res) => res.json() as Promise<ResponseData>)

  if (success && token) {
    setVisitorTokenInfo(token)
  }

  return token
}
